import React, { useMemo, useState } from 'react';

import { Newsletter } from '@utils/backend-api/newsletters';

import Category from './Category';
import Headline from './Headline';

interface ContentProps {
  newsletters: Newsletter[];
}

const Content = ({ newsletters }: ContentProps) => {
  const [currentNewsletters, setCurrentNewsletters] = useState<Newsletter[]>(newsletters);
  const newsletterCattegories = useMemo(() => {
    return [
      {
        name: 'Reporting & Perspective',
        newsletters: currentNewsletters.filter((nl) => !nl.isSubscriberOnly && !nl.isProOnly),
      },
      {
        name: 'Subscriber-only newsletters',
        newsletters: currentNewsletters.filter((nl) => nl.isProOnly || nl.isSubscriberOnly),
      },
    ];
  }, [currentNewsletters]);

  return (
    <div className="px-28">
      <div className="m-auto flex max-w-container-lg flex-col justify-center">
        <Headline setCurrentNewsletters={setCurrentNewsletters} newsletters={currentNewsletters} />
        {newsletterCattegories.map(({ name, newsletters }) => (
          <Category
            key={name}
            setCurrentNewsletters={setCurrentNewsletters}
            name={name}
            newsletters={newsletters}
          />
        ))}
      </div>
    </div>
  );
};

export default Content;
